import { render, staticRenderFns } from "./KoolTip.vue?vue&type=template&id=3f2b30ce&"
import script from "./KoolTip.vue?vue&type=script&lang=js&"
export * from "./KoolTip.vue?vue&type=script&lang=js&"
import style0 from "./KoolTip.vue?vue&type=style&index=0&id=3f2b30ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports